
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'



export default {
directives: {
TransferDom
},
components: {
Tab,
TabItem,
Popup,
XDialog,
Divider,
Confirm,
Toast
},
data() {
return {
parentMsg: "hello",
videoInfo: [],
isAuthoization: true,
videoUrl: "",
VideoLogo: "",
videoSrc: '',
courseName: "",
isFree: false,
CatalogInfo: [],
chapterName: "",
resourceName: "",
courseID: "",
ChapterID: "",
ID: "",
isLogin: false,
CollCourse: [],
CollVideo: [],
showPositionValue: false,
texts: "请输入正确目录名",
show: false,
show1: false,
show2: false,
show3: false,
show31: false,
show32: false,
showLogin: false,
playerOptions: {
playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
autoplay: true, //如果true,浏览器准备好时开始回放。
muted: false, // 默认情况下将会消除任何音频。
loop: false, // 导致视频一结束就重新开始。
preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
language: 'zh-CN',
aspectRatio: '16:10', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
sources: [{
type: "application/x-mpegURL",
src: "" 
}],
hls: true,
poster: "../../static/images/test.jpg", //你的封面地址
width: document.documentElement.clientWidth,
notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
controlBar: {
timeDivider: true,
durationDisplay: true,
remainingTimeDisplay: true,
fullscreenToggle: true 
}
},
isBelongOrg: false,
openVideoDownload: false,
viewVideo: false,
loading: true 
}
},
mounted() {

console.log(this.$route.params)

if (this.$route.params.IDCode != undefined) {
this.courseID = this.$route.params.IDCode;
} else {
this.courseID = localStorage.getItem("NowCourse");
}
if (this.$route.params.ChapterID != undefined) {
this.ChapterID = this.$route.params.ChapterID;
} else {
this.ChapterID = localStorage.getItem("NowChapterID");
}

localStorage.setItem("NowCourse", this.courseID);
localStorage.setItem("NowChapterID", this.ChapterID);


var winHeight = window.innerHeight;
var winWidth = window.innerWidth;
document.getElementById("view").style.height = winHeight * 0.24 + "px";
document.getElementById("video_h5").style.height = winHeight * 0.4 + "px";
document.getElementById("catalog").style["min-height"] = winHeight * 0.24 + "px";

document.getElementById("main").style.height = winHeight * 0.8 + "px";



this.getdownloadLimit();


this.viewVideo = localStorage.getItem("viewVideo") == "true" ? true : false;


this.getCourseData();

if (this.GLOBAL.isLogin == false) {
var hrefUrl = location.host;
hrefUrl = "http://softtone.jqweike.com/login?callback=" + encodeURIComponent(hrefUrl);
document.getElementsByClassName("a")[0].href = hrefUrl;
document.getElementsByClassName("a")[1].href = hrefUrl;
}

this.GLOBAL.IDCode = this.courseID;
this.GLOBAL.ChapterID = this.ChapterID;
this.$router.push({
path: '/Index/Course',
name: '/Index/Course',
params: {
IDCode: this.courseID,
ChapterID: this.ChapterID,
level1: this.$route.params.level1,
level2: this.$route.params.level2,
level3: this.$route.params.level3,
}
});
},
methods: {
onPlayerReady(player) {



player.on('play', () => {

})

player.on('error', (error) => {
alert('视频加载失败:');
});

},
onPlayerDataLoaded(){

setTimeout(() => {
this.loading = false;
}, 500)
},
InitVideo(v, logo) {
if (v.includes(".mp4")) {
this.playerOptions.sources[0].type = "video/mp4";
} else {

}
this.playerOptions.sources[0].src = v;
this.playerOptions.poster = logo;
},
videoDown() {
/* alert(this.videoUrl) */
if (!this.isBelongOrg) {
alert("您的位置没有在机构内，不可以下载视频");
} else if (!this.openVideoDownload) {
alert("您还没有开通下载视频权限，请联系管理员");
} else {
window.open(this.videoUrl)
}
},
getdownloadLimit() {
this.$tyh.getdownloadLimit()
.then((response) => {
var data = response.data;
if (data.Status == 0) {
var json = data.Data;
if (json.IsEnable) {
this.openVideoDownload = true;
}
}
});

var ipVerified = localStorage.getItem("ipVerified");

if (ipVerified == "true" || ipVerified == true) {
this.isBelongOrg = true;
} else {
this.isBelongOrg = false;
}


},
goBack() {
location.href = "http://" + apiConfig.WEBURL;
},

GetCatalog: function() {

this.$api.CollectCatalog("crs")
.then((data) => {
if (data.data.Status != 0) {
return;
}
this.CollCourse = [];
this.CollCourse = data.data.Data.rows;
})

this.$api.CollectCatalog("vid")
.then((data) => {
if (data.data.Status != 0) {
return;
}
this.CollVideo = [];
this.CollVideo = data.data.Data.rows;
})
},

onConfirm: function(value) {
if (value != "" && value != null && value != undefined) {
this.$api.AddCollectGroupList("vid", value)
.then((data) => {
if (data.data.Status == 0) {
this.texts = "添加成功"
this.GetCatalog();
} else {
this.texts = data.data.Data
}
})
} else {
this.texts = "请输入正确目录名"
}
this.showPositionValue = true;


},

onConfirm1: function(value) {
if (value != "" && value != null && value != undefined) {
this.$api.AddCollectGroupList("crs", value)
.then((data) => {
if (data.data.Status == 0) {
this.texts = "添加成功"
this.GetCatalog();
} else {
this.texts = data.data.Data
}
})
} else {
this.texts = "请输入正确目录名"
}
this.showPositionValue = true;

},

AddCollect: function() {
var ChapterID = this.GLOBAL.ChapterID;
var IDCode = this.GLOBAL.IDCode;

var radios = document.getElementsByName("demo-radio");

var selectvalue = null; 
for (var i = 0; i < radios.length; i++) {
if (radios[i].checked == true) {
selectvalue = radios[i].value;
break;
}
}

if (selectvalue == "收藏本视频") {
var obj = document.getElementById("one"); 
var index = obj.selectedIndex; 
var value = obj.options[index].value; 

if (ChapterID == undefined || ChapterID == "" || ChapterID == null ||
IDCode == undefined || IDCode == "" || IDCode == null) {
this.texts = "错误，未正确获取课程或视频";
this.showPositionValue = true;
} else {
this.$tyh.GetByChapterID(ChapterID) 
.then((data) => {
if (data.data.Status != 0) {
return;
}
var ContextID = data.data.Data.resource.ID;
for (var i in this.CollVideo) {
if (this.CollVideo[i].Name == value) {
var addBody = {
FavTypeNo: "vid",
CategoryID: this.CollVideo[i].ID,
ContextID: ContextID
}

this.$api.addConllect(addBody)
.then((data) => {

if (data.data.Status == 0) {

this.texts = "收藏成功";

this.AddLog("StoreVideo");

this.$api.SetScore("CollectionScore")
.then((data) => {
if (data.data.Status == 1) {

}
})
} else {
if (data.data.Data == "已收藏") {
this.texts = "已在收藏中";
}
}
this.showPositionValue = true;
})
}
}
})


}
}

if (selectvalue == "收藏本课程") {

var obj = document.getElementById("two"); 
var index = obj.selectedIndex; 
var value = obj.options[index].value; 

if (IDCode == undefined || IDCode == "" || IDCode == null) {
this.texts = "错误，未正确获取课程";
this.showPositionValue = true;
} else {

for (var i in this.CollCourse) {
if (this.CollCourse[i].Name == value) {
var addBody = {
FavTypeNo: "crs",
CategoryID: this.CollCourse[i].ID,
ContextID: IDCode
}

this.$api.addConllect(addBody)
.then((data) => {
if (data.data.Status == 0) {
this.texts = "收藏成功";

this.AddLog("StoreCourse");

this.$api.SetScore("CollectionScore")
.then((data) => {
if (data.data.Status == 1) {

}
})

} else {
if (data.data.Data == "已收藏") {
this.texts = "已在收藏中";
}
}
this.showPositionValue = true;
})
}
}
}

}



},

AddLog: function(type) {
var ChapterID = this.GLOBAL.ChapterID;
var IDCode = this.GLOBAL.IDCode;

if (type == "StoreCourse") {
this.$api.GetCourse([IDCode]) 
.then((data) => {
if (data.data.Status == 0) {
this.$tyh.AddLog(IDCode, data.data.Data[0].Name, type) 
.then((data) => {
if (data.data.Status == 0) {

}
});
}

})

} else if (type == "StoreVideo") {
this.$tyh.GetByChapterID(ChapterID)
.then((data) => {
this.$tyh.AddLog(IDCode + "/" + ChapterID, data.data.Data.resource.Name, type)
.then((data) => {
if (data.data.Status == 0) {

}
});

})
}
},

Share: function(type) {
var IDCode = this.GLOBAL.IDCode;
var ChapterID = this.GLOBAL.ChapterID;

var ResUrl = this.$api.PERSONALURL;
var WebUrl = this.$api.URL;

this.$api.GetCourse([IDCode])
.then((data) => {


var Name = data.data.Data[0].Name;

var urlData = IDCode + "/" + ChapterID;
var url = WebUrl + "/index/video/" + urlData;
var picurl = ResUrl + data.data.Data[0].Image;

if (type == "qzone") {
var sharestring =
'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' +
'url=' + url +
'&title=' + Name +
'&pics=' + Name +
'&summary=' + Name +
'&desc=' + Name;
alert(sharestring)
window.open(sharestring, 'newwindow', 'height=400,width=400,top=100,left=100');
} else if (type == "sinaminiblog") {
var sharestring = 'http://v.t.sina.com.cn/share/share.php?' +
'title=' + Name +
'&url=' + url +
'&content=utf-8&sourceUrl=' + url +
'&pic=' + picurl;
window.open(sharestring, 'newwindow', 'height=400,width=400,top=100,left=100');
} else if (type == "weixin") {
this.show1 = false;
this.show2 = true;
document.getElementById("qrcodeInput").value = url;
document.getElementById("qrcode").innerHTML = "";
var qrcode = new QRCode(document.getElementById("qrcode"), {
text: url,
width: 128,
height: 128,
colorDark: "#000000",
colorLight: "#ffffff",
correctLevel: QRCode.CorrectLevel.H
});
}


})
},

CopyUrl: function() {
var Text = document.getElementById("qrcodeInput");
Text.select(); 
document.execCommand("Copy"); 
if (window.getSelection().toString() == Text.value) {
this.texts = "复制成功"
this.showPositionValue = true;
};
},

isCollect: function(id) {},
gerID: function(index) {
return "level" + index;
},
gerID2: function(index1, index) {
return "levels" + index1 + index;
},
jump: function(url) {
document.getElementById("catalog").style.display = "none";
document.getElementById("view").style.display = "block";
this.$router.push({
path: url,
name: url,
params: {
IDCode: this.courseID,
ID: this.ID,
level1: this.$route.params.level1,
level2: this.$route.params.level2,
level3: this.$route.params.level3,
}
})
},
CatalogShow: function() {
document.getElementById("catalog").style.display = "block";
document.getElementById("view").style.display = "none";
},
chapterView: function(chapterName, id, resourceName, index, isLock) {
if (isLock) {
return;
}

this.GLOBAL.ChapterID = id;

var cLevel2 = document.getElementsByClassName("cLevel2");
for (var i = 0; i < cLevel2.length; i++) {
cLevel2[i].style.color = "#0F0F0F"
}
var cLevel = document.getElementsByClassName("cLevel");
for (var i = 0; i < cLevel.length; i++) {
cLevel[i].style.color = "#0F0F0F"
}
event.target.style.color = "rgb(255,69,0)"


var iscLevel = false;
if (event.target.className == "cLevel2") {
var nextElement = event.target.nextElementSibling;
if (nextElement.innerHTML.length > 0) {
iscLevel = true;
}
}

if (iscLevel) {
if (nextElement.style.display == "none") {
nextElement.style.display = "block"
} else {
nextElement.style.display = "none"
}
} else {
this.$tyh.GetByChapterID(id)
.then((data) => {
if (data.data.Status === 0) {
console.log(data.data.Data)
this.videoUrl = this.$tyh.RESOURCEURL + data.data.Data.resource.VideoFile;
this.VideoLogo = this.$tyh.RESOURCEURL + data.data.Data.resource.Logo;

this.InitVideo(this.videoUrl, this.VideoLogo);

this.courseName = data.data.Data.courseName;
this.chapterName = chapterName;
this.resourceName = resourceName;
this.ChapterID = data.data.Data.resource.ChapterID;
this.ID = data.data.Data.resource.ID;

this.$tyh.AddLog(this.courseID + "/" + this.ChapterID, this.resourceName,
"ReadVideo")
.then((data) => {
if (data.data.Status == 0) {


this.$api.SetScore("VideoPlay")
.then((data) => {
if (data.data.Status == 1) {

}
})
}
});
}
})
}

},
getCourseData: function() {
var orgID = localStorage.getItem("orgId");
this.$tyh.GetCourse(this.courseID, orgID)
.then((data) => {


var IDList = ["Course51557", "KC0028", "Course51556", "KC0165", "Course51559", "KC0043",
"Course51560",
"KC0015"
];
if (IDList.indexOf(this.courseID) >= 0) {
this.isAuthoization = true;
this.viewVideo = true;

} else {

var isFree = data.data.Data.course.isFree === true ? true : false;
if (isFree == true) {
this.isAuthoization = true;
this.viewVideo = true;
}
this.isAuthoization = data.data.Data.isAuthoization;


if (this.viewVideo == true) {
this.IsCertified(data.data.Data.chapter);
} else {

if (localStorage.getItem("isLogged") == "true") {
this.getTopTenCourse(data.data.Data.chapter);
} else {
this.showLogin = true;
return;
}
}

}

if (this.isAuthoization == false) {
return;
}

this.GetCatalog();

this.videoInfo = data.data.Data;
this.CatalogInfo = data.data.Data.chapter;


this.GLOBAL.ChapterID = data.data.Data.firstChapterID;
this.ChapterID = data.data.Data.firstChapterID;
if (this.ChapterID != "" && this.ChapterID != undefined) {
this.ChapterID = this.ChapterID;
this.$tyh.GetByChapterID(this.ChapterID)
.then((data) => {
this.videoUrl = this.$tyh.RESOURCEURL + data.data.Data.resource.VideoFile;
this.VideoLogo = this.$tyh.RESOURCEURL + data.data.Data.resource.Logo;

this.InitVideo(this.videoUrl, this.VideoLogo);

this.ID = data.data.Data.resource.ID;
this.courseName = data.data.Data.courseName;
this.chapterName = "";
for (var i in this.CatalogInfo) {
for (var c in this.CatalogInfo[i].Sub) {
if (this.ChapterID == this.CatalogInfo[i].Sub[c].ID) {
this.chapterName = this.CatalogInfo[i].Name;
this.resourceName = this.CatalogInfo[i].Sub[c].Name
}
}
}

this.$tyh.AddLog(data.data.Data.resource.CourseIDCode + "/" + data.data
.Data.resource.ChapterID, this.resourceName,
"ReadVideo")
.then((data) => {
if (data.data.Status == 0) {}
});
});
} else {

this.$tyh.GetByChapterID(this.videoInfo.firstChapterID)
.then((data) => {
if (data.data.Status != 0) {
return;
}

this.videoUrl = this.$tyh.RESOURCEURL + data.data.Data.resource.VideoFile;
this.VideoLogo = this.$tyh.RESOURCEURL + data.data.Data.resource.Logo;

this.InitVideo(this.videoUrl, this.VideoLogo);

this.courseName = data.data.Data.courseName;
this.chapterName = this.videoInfo.chapter[0].Name;

if (this.videoInfo.chapter[0].Sub != null &&
this.videoInfo.chapter[0].Sub != undefined) {
this.resourceName = this.videoInfo.chapter[0].Sub[0].Name;
}
this.courseID = data.data.Data.resource.CourseIDCode;
this.$tyh.AddLog(data.data.Data.resource.CourseIDCode, this.courseName,
"ReadCourse")
.then((datas) => {
if (datas.data.Data.Status == 0) {

}
});
});
}

});

},

getTopTenCourse: function(CourseList) {
var num = 0;

for (var i in CourseList) {

var datas = {
CourseIDCode: CourseList[i].CourseIDCode,
CreateTime: CourseList[i].CreateTime,
ID: CourseList[i].ID,
Name: CourseList[i].Name,
PlayTime: CourseList[i].PlayTime,
IsLock: false,
Sub: CourseList[i].Sub
}
CourseList[i] = datas;

if (!CourseList[i].IsRecourse) {
for (var j in CourseList[i].Sub) {
num++;
if (num > 10) {
var isLock = true;
} else {
var isLock = false;
}
var data = {
CourseIDCode: CourseList[i].Sub[j].CourseIDCode,
CreateTime: CourseList[i].Sub[j].CreateTime,
ID: CourseList[i].Sub[j].ID,
Name: CourseList[i].Sub[j].Name,
PID: CourseList[i].Sub[j].PID,
PlayTime: CourseList[i].Sub[j].PlayTime,
IsLock: isLock
}
CourseList[i].Sub[j] = data;
}
}
}

if (num == 0) {
for (var i in CourseList) {
if (i > 9) {
var isLock = true;
} else {
var isLock = false;
}
var data = {
CourseIDCode: CourseList[i].CourseIDCode,
CreateTime: CourseList[i].CreateTime,
ID: CourseList[i].ID,
Name: CourseList[i].Name,
PlayTime: CourseList[i].PlayTime,
IsLock: isLock
}
CourseList[i] = data;
}
}
this.CatalogInfo = CourseList;
},

IsCertified: function(CourseList) {
for (var i in CourseList) {

var datas = {
CourseIDCode: CourseList[i].CourseIDCode,
CreateTime: CourseList[i].CreateTime,
ID: CourseList[i].ID,
Name: CourseList[i].Name,
PlayTime: CourseList[i].PlayTime,
IsLock: false,
Sub: CourseList[i].Sub
}
CourseList[i] = datas;

if (!CourseList[i].IsRecourse) {
for (var j in CourseList[i].Sub) {
var data = {
CourseIDCode: CourseList[i].Sub[j].CourseIDCode,
CreateTime: CourseList[i].Sub[j].CreateTime,
ID: CourseList[i].Sub[j].ID,
Name: CourseList[i].Sub[j].Name,
PID: CourseList[i].Sub[j].PID,
PlayTime: CourseList[i].Sub[j].PlayTime,
IsLock: false
}
CourseList[i].Sub[j] = data;
}
}
}
this.CatalogInfo = CourseList;
},
},
watch: {
'$route'(to, from) {


if (this.$route.path == "/Index/Course") {

this.GLOBAL.IDCode = this.courseID;
this.GLOBAL.ChapterID = this.ChapterID;
this.$router.push({
path: '/Index/Course',
name: '/Index/Course',
params: {
IDCode: this.courseID,
ChapterID: this.ChapterID,
level1: this.$route.params.level1,
level2: this.$route.params.level2,
level3: this.$route.params.level3,
}
});

this.getCourseData();
}
}
}

}



// WEBPACK FOOTER //
// ./src/views/Index/Course.vue